"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var Tab;
(function (Tab) {
    Tab[Tab["Files"] = 1] = "Files";
    Tab[Tab["Device"] = 2] = "Device";
    Tab[Tab["ThisProduct"] = 3] = "ThisProduct";
    Tab[Tab["OtherProduct"] = 4] = "OtherProduct";
})(Tab || (exports.Tab = Tab = {}));
